import React, {Children, cloneElement} from 'react'

import TimelineItem from 'components/elements/Timeline/TimelineItem'

interface ITimelineProps {
	className?: string
	children?: React.ReactNode

	/** Index of active element */
	active?: number
	Item?: typeof TimelineItem
}

const Timeline = ({className, children, active = -1}: ITimelineProps) => {
	const _children = Children.toArray(children)
	const items = _children?.map((item: any, index) =>
		cloneElement(item, {
			active: item.props?.active || active! >= index,
			lineActive: item.props?.lineActive || active! - 1 >= index,
		}),
	)

	return <div className={className}>{items}</div>
}

Timeline.Item = TimelineItem
Timeline.displayName = 'Timeline'

export default Timeline
